<template>
  <v-menu v-model="showMenu" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="text-capitalize" v-bind="attrs" v-on="on" text>
        <v-icon left>mdi-translate</v-icon>
        {{ $t(`language.${$i18n.locale}`) }}
        <v-icon small right>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(lang, index) in langItems"
        :key="index"
        @click="changeLang(lang.value)"
      >
        <v-list-item-title>
          <LanguageIcon :lang="lang.value"></LanguageIcon>
          {{ $t(lang.text) }}
        </v-list-item-title>
      </v-list-item>
      <template v-if="showSetDefaultLang">
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-title>
            <router-link :to="{ name: 'Profile' }" class="text-decoration-none">
              {{ $t("menu.setDefaultLang") }}
              <v-icon small>mdi-open-in-new</v-icon>
            </router-link>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { Lang } from "@/utils/lang.enum";
import { mapEnumToItem } from "@/utils/map-enum-to-items.function";
import Vue from "vue";
import Component from "vue-class-component";
import LanguageIcon from "@/components/common/icons/LanguageIcon.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    LanguageIcon,
  },
})
export default class LangMenu extends Vue {
  @Prop({ type: Boolean, default: false })
  public showSetDefaultLang!: boolean;

  public showMenu = false;

  public readonly langItems = mapEnumToItem(Lang, "language");

  changeLang(lang: string) {
    this.$i18n.locale = lang;
    this.$store.commit("user/setLang", lang);
  }
}
</script>
